<template>
  <div>
    <b-card>
      <div class="row">
        <div class="col-lg-12">
          <h4>Munka gép szerkesztése</h4>
        </div>
      </div>
    </b-card>
    <form-wizard
      ref="wizard"
      color="#3e74c7"
      :title="null"
      :subtitle="null"
      :enable-finish-button="true"
      layout="vertical"
      finish-button-text="Frissítés"
      next-button-text="Tovább"
      next-button-icon="fa fa-arrow-right"
      back-button-text="Vissza"
      class="wizard-vertical mb-3"
      tabindex="3"
      @on-complete="update"
    >

      <!-- account datails tab -->
      <tab-content title="Munka gép adatai">
        <div class="row">
          <h5 class="col-lg-6 mb-0 pb-0">
            Munka gép adatai
          </h5>
          <div class="col-lg-6 text-right">
            <button
              class="btn btn-primary"
              @click="update"
            >
              Frissítés
            </button>
          </div>
          <b-form-group
            label="Munkagép megnevezése"
            label-for="name"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="name"
              v-model="name"
              type="text"
              placeholder="Munkagép megnevezése"
            />
          </b-form-group>
          <b-form-group
            label="Gyártmány"
            label-for="brand"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="brand"
              v-model="brand"
              type="text"
              placeholder="Gyártmány"
            />
          </b-form-group>
          <b-form-group
            label="Típus"
            label-for="type"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="type"
              v-model="type"
              type="text"
              placeholder="Típus"
            />
          </b-form-group>
          <b-form-group
            label="Rendszám"
            label-for="registration_number"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="registration_number"
              v-model="registration_number"
              type="text"
              placeholder="Rendszám (nem kötelező)"
            />
          </b-form-group>
          <b-form-group
            label="Forgalomba helyezés ideje"
            label-for="entry_into_service"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="entry_into_service"
              v-model="entry_into_service"
              type="date"
              max="9999-12-31"
              placeholder="Forgalomba helyezés ideje"
            />
          </b-form-group>
          <b-form-group
            label="Gyártási év"
            label-for="year_of_manufacture"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="year_of_manufacture"
              v-model="year_of_manufacture"
              type="number"
              placeholder="Gyártási év"
            />
          </b-form-group>
          <b-form-group
            label="Műszaki vizsga lejárata"
            label-for="technical_validity"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="technical_validity"
              v-model="technical_validity"
              type="date"
              max="9999-12-31"
              placeholder="Műszaki vizsga lejárata"
            />
          </b-form-group>
          <b-form-group
            label="Gyártási szám"
            label-for="manufacturing_number"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="manufacturing_number"
              v-model="manufacturing_number"
              type="text"
              placeholder="Gyártási szám"
            />
          </b-form-group>
          <b-form-group
            label="Aktuális üzemóra"
            label-for="current_hours"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="current_hours"
              v-model="current_hours"
              type="number"
              placeholder="Aktuális üzemóra"
            />
          </b-form-group>
          <b-form-group
            label="Szervíz intervallum"
            label-for="service_interval"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="service_interval"
              v-model="service_interval"
              type="number"
              placeholder="Szervíz intervallum"
            />
          </b-form-group>
        </div>

      </tab-content>
      <tab-content title="Szervíz">
        <div class="row mb-5">
          <h5 class="col-lg-6 mb-0 pb-0">
            Új szervíz hozzáadása
          </h5>
          <div class="col-lg-6 text-right">
            <button
              class="btn btn-primary"
              @click="update"
            >
              Frissítés
            </button>
          </div>
          <b-form-group
            label="Szervíz neve"
            label-for="service_service_name"
            class="col-md-2 mt-1"
          >
            <b-form-input
              id="service_service_name"
              v-model="service_service_name"
              type="text"
              placeholder="Szervíz neve"
            />
          </b-form-group>
          <b-form-group
            label="Számlaszám"
            label-for="service_billing_number"
            class="col-md-2 mt-1"
          >
            <b-form-input
              id="service_billing_number"
              v-model="service_billing_number"
              type="text"
              placeholder="Számlaszám"
            />
          </b-form-group>
          <b-form-group
            label="Elvégzés dátuma"
            label-for="service_date_of_completion"
            class="col-md-2 mt-1"
          >
            <b-form-input
              id="service_date_of_completion"
              v-model="service_date_of_completion"
              type="date"
              placeholder="Elvégzés dátuma"
            />
          </b-form-group>
          <b-form-group
            label="Üzemóra szervízkor"
            label-for="service_hours_at_the_time_of_service"
            class="col-md-3 mt-1"
          >
            <b-form-input
              id="service_hours_at_the_time_of_service"
              v-model="service_hours_at_the_time_of_service"
              type="number"
              placeholder="Üzemóra szervízkor"
            />
          </b-form-group>
          <b-form-group
            label="Szervíz intervallum"
            label-for="service_service_interval"
            class="col-md-3 mt-1"
          >
            <b-form-input
              id="service_service_interval"
              v-model="service_service_interval"
              type="text"
              placeholder="pl. 500 óra"
            />
          </b-form-group>
          <div class="col-lg-12 mt-2">
            <h6>Általános szolgáltatások</h6>
            <div class="d-flex flex-wrap gap-1">
              <b-button
                v-for="service in predefinedServices"
                :key="service"
                variant="outline-primary"
                size="sm"
                class="mr-1 mb-1"
                @click="addPredefinedService(service)"
              >
                <feather-icon
                  icon="PlusIcon"
                  size="14"
                  class="mr-1"
                />
                {{ service }}
              </b-button>
            </div>
          </div>
          <div class="col-lg-6 mt-2">
            <h6>Szolgáltatás hozzáadása</h6>
            <b-form-input
              id="service_name_of_service_uniq"
              v-model="service_name_of_service_uniq"
              type="text"
              placeholder="Szolgáltatás neve"
            />
            <button
              class="btn btn-outline-primary w-100 text-center mt-2"
              @click="addToServicesUniq()"
            >
              <feather-icon
                icon="PlusIcon"
                size="16"
                class="mr-1"
              />
              Szolgáltatás hozzáadása
            </button>
          </div>
          <div class="col-lg-6 mt-2">
            <h6>Rögzített szolgáltatások</h6>
            <div
              class="service-badges"
              style="min-height: 80px;"
            >
              <span
                v-for="(service, index) in service_name_of_service"
                :key="index"
                style="cursor:pointer"
                class="badge badge-primary mr-1 mb-1"
                @click="removeService(index)"
              >
                {{ service }}
                <feather-icon
                  icon="XIcon"
                  size="14"
                  class="ml-1"
                />
              </span>
              <small
                v-if="service_name_of_service.length === 0"
                class="text-muted"
              >
                Még nincs szolgáltatás hozzáadva
              </small>
            </div>
          </div>
          <div class="col-md-12 mt-1">
            <button
              type="button"
              class="btn btn-primary"
              :disabled="service_name_of_service.length === 0"
              @click="addService"
            >
              <feather-icon
                icon="SaveIcon"
                size="16"
                class="mr-1"
              />
              Szervíz hozzáadása
            </button>
          </div>
          <div class="col-lg-12 mt-3">
            <h5>Meglévő szervízek</h5>
            <vue-good-table
              :columns="serviceColumns"
              :rows="services"
              :pagination-options="{
                enabled: true,
                perPage: 10
              }"
            >
              <template
                slot="table-row"
                slot-scope="props"
              >
                <span v-if="props.column.field === 'action'">
                  <b-button
                    variant="outline-danger"
                    size="sm"
                    class="ml-1"
                    @click="removeServiceFull(props.row.id)"
                  >
                    Törlés
                  </b-button>
                </span>
                <span v-else-if="props.column.field === 'name_of_service'">
                  <div v-if="Array.isArray(props.row.name_of_service)">
                    <b-badge
                      v-for="(service, index) in props.row.name_of_service"
                      :key="index"
                      variant="primary"
                      class="mr-1 mb-1"
                      style="color: white !important;"
                    >
                      {{ service }}
                    </b-badge>
                  </div>
                  <span v-else>
                    {{ props.row.name_of_service }}
                  </span>
                </span>
                <span v-else-if="props.column.field === 'service_interval'">
                  {{ formatServiceNextDue(props.row) }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </tab-content>
      <tab-content title="Biztosítások">
        <div class="row">
          <h5 class="col-lg-6 mb-2 pb-0">
            Biztosítások
          </h5>
          <div class="col-lg-6 text-right">
            <button
              class="btn btn-primary"
              @click="update"
            >
              Frissítés
            </button>
          </div>
          <div class="col-lg-12 mt-2 mb-5">
            <div class="row">
              <hr class="col-lg-12">
              <div class="col-lg-12">
                <p>Létrehozás</p>
              </div>
              <div class="col-lg-2">
                <small>Biztosító neve</small>
                <b-form-input
                  id="insurance_name"
                  v-model="insurance_name"
                  type="text"
                  placeholder="Biztosító neve"
                />
              </div>
              <div class="col-lg-2">
                <small>Biztosítás típusa</small>
                <b-form-select
                  id="insurance_type"
                  v-model="insurance_type"
                  :options="['Kötelező gépjármű biztosítás', 'Casco']"
                  placeholder="Biztosítás típusa"
                />
              </div>
              <div class="col-lg-2">
                <small>Fizetés gyakorisága</small>
                <b-form-select
                  id="insurance_frequency"
                  v-model="insurance_frequency"
                  :options="['Havi', 'Éves', 'Negyedéves']"
                  placeholder="Fizetés gyakorisága"
                />
              </div>
              <div class="col-lg-2">
                <small>Biztosítás kötvényszáma</small>
                <b-form-input
                  id="policy_number"
                  v-model="policy_number"
                  type="text"
                  placeholder="Biztosítás kötvényszáma"
                />
              </div>
              <div class="col-lg-2">
                <small>Biztosítás ára</small>
                <b-form-input
                  id="price"
                  v-model="price"
                  type="number"
                  placeholder="Biztosítás ára"
                />
              </div>
              <div class="col-lg-2">
                <small>Biztosítás lejárata</small>
                <b-form-input
                  id="expiry_date"
                  v-model="expiry_date"
                  type="date"
                  max="9999-12-31"
                  placeholder="Biztosítás lejárata"
                />
              </div>
              <div class="col-lg-12">
                <b-button
                  variant="primary"
                  class="w-100 mt-2 btn btn-primary"
                  @click="addInsurance"
                >
                  Létrehozás
                  <feather-icon
                    icon="PlusIcon"
                  />
                </b-button>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <hr>
          </div>
          <div
            v-for="(insur, index) in insurance"
            :key="index"
            class="col-lg-12 mt-2"
          >
            <div class="row">
              <div class="col-lg-2 text-center">
                <span
                  v-if="today_date > insur.expiry_date"
                  class="badge badge-danger mt-2"
                >Lejárt</span>
                <span
                  v-else
                  class="badge badge-success mt-2"
                >Érvényes</span>
              </div>
              <div class="col-lg-2">
                <small>Biztosító neve</small>
                <b-form-input
                  :id="'insurance_name_'+index"
                  v-model="insur.insurance_name"
                  type="text"
                  placeholder="Biztosító neve"
                />
              </div>
              <div class="col-lg-2">
                <small>Biztosítás típusa</small>
                <b-form-select
                  :id="'insurance_type_'+index"
                  v-model="insur.insurance_type"
                  :options="['Kötelező gépjármű biztosítás', 'Casco']"
                  placeholder="Biztosítás típusa"
                />
              </div>
              <div class="col-lg-2">
                <small>Fizetés gyakorisága</small>
                <b-form-select
                  :id="'insurance_frequency_'+index"
                  v-model="insur.insurance_frequency"
                  :options="['Havi', 'Éves', 'Negyedéves']"
                  placeholder="Fizetés gyakorisága"
                />
              </div>
              <div class="col-lg-2">
                <small>Biztosítás kötvényszáma</small>
                <b-form-input
                  :id="'policy_number_'+index"
                  v-model="insur.policy_number"
                  type="text"
                  placeholder="Biztosítás kötvényszáma"
                />
              </div>
              <div class="col-lg-1 mt-2">
                <b-button
                  variant="primary"
                  class="btn btn-primary w-100"
                  @click="updateInsurance(index)"
                >
                  <feather-icon
                    icon="SaveIcon"
                  />
                </b-button>
              </div>
              <div class="col-lg-1 mt-2">
                <b-button
                  class="btn btn-danger w-100"
                  @click="removeInsurance(index)"
                >
                  <feather-icon
                    icon="TrashIcon"
                  />
                </b-button>
              </div>
              <div class="col-lg-2">
                <small>Biztosítás lejárata</small>
                <b-form-input
                  :id="'expiry_date_'+index"
                  v-model="insur.expiry_date"
                  type="date"
                  max="9999-12-31"
                  placeholder="Biztosítás lejárata"
                />
              </div>
              <div class="col-lg-2">
                <small>Biztosítás ára</small>
                <b-form-input
                  :id="'price_'+index"
                  v-model="insur.price"
                  type="number"
                  placeholder="Biztosítás ára"
                />
              </div>
            </div>
            <hr class="mt-3">
          </div>
        </div>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BFormGroup,
  BFormInput,
  BFormSelect,
  BCard,
  BButton,
  BBadge,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import axios from 'axios'

export default {
  components: {
    FormWizard,
    TabContent,
    BCard,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    VueGoodTable,
    BBadge,
    FeatherIcon,
  },
  data() {
    return {
      name: '',
      brand: '',
      type: '',
      registration_number: '',
      entry_into_service: '',
      year_of_manufacture: '',
      technical_validity: '',
      manufacturing_number: '',
      current_hours: '',
      service_interval: '',
      service_service_name: '',
      service_billing_number: '',
      services: [],
      service_date_of_completion: '',
      service_hours_at_the_time_of_service: '',
      service_name_of_service: [],
      service_name_of_service_uniq: '',
      service_service_interval: '',
      insurance_name: '',
      insurance_frequency: '',
      insurance_type: '',
      policy_number: '',
      expiry_date: '',
      price: '',
      insurance: [],
      today_date: new Date().toISOString().substr(0, 10),
      predefinedServices: [
        'Olajszűrő',
        'Olaj',
        'Levegőszűrő',
        'Pollenszűrő',
        'Üzemanyagszűrő',
        'Hidraulika olaj',
        'Hidraulika szűrő',
        'Váltóolaj',
      ],
      serviceColumns: [
        {
          label: 'Szervíz neve',
          field: 'service_name',
        },
        {
          label: 'Számlaszám',
          field: 'billing_number',
        },
        {
          label: 'Elvégzés dátuma',
          field: 'date_of_completion',
        },
        {
          label: 'Üzemóra szervízkor',
          field: 'hours_at_the_time_of_service',
        },
        {
          label: 'Szolgáltatások',
          field: 'name_of_service',
        },
        {
          label: 'Következő esedékes szervíz',
          field: 'service_interval',
        },
        {
          label: 'Műveletek',
          field: 'action',
        },
      ],
    }
  },
  watch: {
    current_hours(newValue) {
      if (!this.service_hours_at_the_time_of_service || this.service_hours_at_the_time_of_service === this.current_hours) {
        this.service_hours_at_the_time_of_service = newValue
      }
    },
    service_interval(newValue) {
      if (!this.service_service_interval || this.service_service_interval === this.service_interval) {
        this.service_service_interval = newValue
      }
    },
  },
  mounted() {
    this.getWorkMachine()
    this.getService()
    this.getInsurance()
    const { wizard } = this.$refs
    if (wizard && Array.isArray(wizard.tabs)) {
      const steps = wizard.tabs.length - 1
      for (let index = 0; index < steps; index += 1) {
        wizard.nextTab()
      }
      for (let index = 0; index < steps; index += 1) {
        wizard.prevTab()
      }
    }
  },
  methods: {
    getService() {
      axios({
        method: 'get',
        url: `work-machine/${this.$route.params.id}/service/list`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        this.services = response.data
      })
    },
    getInsurance() {
      axios({
        method: 'get',
        url: `work-machine-insurance/list/${this.$route.params.id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        this.insurance = response.data
      })
    },
    addService() {
      axios({
        method: 'post',
        url: `work-machine/${this.$route.params.id}/service/create`,
        data: {
          service_name: this.service_service_name,
          billing_number: this.service_billing_number,
          date_of_completion: this.service_date_of_completion,
          hours_at_the_time_of_service: this.service_hours_at_the_time_of_service,
          name_of_service: this.service_name_of_service,
          service_interval: this.service_service_interval,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeres hozzáadás!',
            text: 'A szervíz sikeresen hozzáadva.',
            variant: 'success',
          },
        })
        this.getService()
        this.service_service_name = ''
        this.service_billing_number = ''
        this.service_date_of_completion = ''
        this.service_hours_at_the_time_of_service = this.current_hours
        this.service_name_of_service = []
        this.service_name_of_service_uniq = ''
        this.service_service_interval = this.service_interval
      })
    },
    removeServiceFull(index) {
      axios({
        method: 'delete',
        url: `work-machine/service/delete/${index}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.getService()
      })
    },
    addToServicesUniq() {
      if (this.service_name_of_service_uniq.trim() !== '' && this.service_name_of_service.indexOf(this.service_name_of_service_uniq.trim()) === -1) {
        this.service_name_of_service.push(this.service_name_of_service_uniq.trim())
        this.service_name_of_service_uniq = ''
      }
    },
    addPredefinedService(serviceName) {
      if (this.service_name_of_service.indexOf(serviceName) === -1) {
        this.service_name_of_service.push(serviceName)
      }
    },
    removeService(index) {
      this.service_name_of_service.splice(index, 1)
    },
    formatServiceNextDue(service) {
      if (!service) {
        return 'Nincs adat'
      }

      const base = parseInt(service.hours_at_the_time_of_service, 10)
      const interval = parseInt(service.service_interval, 10)

      if (!Number.isNaN(base) && !Number.isNaN(interval)) {
        return `${base + interval} óra`
      }

      if (!Number.isNaN(interval)) {
        return `${interval} óra`
      }

      return 'Nincs adat'
    },
    getWorkMachine() {
      axios({
        method: 'get',
        url: `work-machine/list/${this.$route.params.id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(res => {
        this.name = res.data.name
        this.brand = res.data.brand
        this.type = res.data.type
        this.registration_number = res.data.registration_number
        this.entry_into_service = res.data.entry_into_service
        this.year_of_manufacture = res.data.year_of_manufacture
        this.technical_validity = res.data.technical_validity
        this.manufacturing_number = res.data.manufacturing_number
        this.current_hours = res.data.current_hours
        this.service_interval = res.data.service_interval
        this.service_service_interval = res.data.service_interval
        this.service_hours_at_the_time_of_service = res.data.current_hours
      })
    },
    removeInsurance(index) {
      axios({
        method: 'delete',
        url: `work-machine-insurance/delete/${this.insurance[index].id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.getInsurance()
      })
    },
    updateInsurance(index) {
      axios({
        method: 'put',
        url: `work-machine-insurance/update/${this.insurance[index].id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        data: {
          insurance_name: this.insurance[index].insurance_name,
          policy_number: this.insurance[index].policy_number,
          expiry_date: this.insurance[index].expiry_date,
          price: this.insurance[index].price,
          insurance_frequency: this.insurance[index].insurance_frequency,
          insurance_type: this.insurance[index].insurance_type,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeres frissítés!',
            text: 'A biztosítás sikeresen frissítve.',
            variant: 'success',
          },
        })
        this.getInsurance()
      })
    },
    addInsurance() {
      axios({
        method: 'post',
        url: `work-machine-insurance/create/${this.$route.params.id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        data: {
          insurance_name: this.insurance_name,
          policy_number: this.policy_number,
          expiry_date: this.expiry_date,
          price: this.price,
          insurance_frequency: this.insurance_frequency,
          insurance_type: this.insurance_type,
        },
      }).then(() => {
        this.getInsurance()
        this.insurance_name = ''
        this.policy_number = ''
        this.expiry_date = ''
        this.price = ''
        this.insurance_frequency = ''
        this.insurance_type = ''
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeres hozzáadás!',
            text: 'A biztosítás sikeresen rögzítve.',
            variant: 'success',
          },
        })
      })
    },
    update() {
      axios({
        method: 'put',
        url: `work-machine/update/${this.$route.params.id}`,
        data: {
          name: this.name,
          brand: this.brand,
          type: this.type,
          registration_number: this.registration_number,
          entry_into_service: this.entry_into_service || null,
          year_of_manufacture: this.year_of_manufacture,
          technical_validity: this.technical_validity || null,
          manufacturing_number: this.manufacturing_number,
          current_hours: this.current_hours,
          service_interval: this.service_interval,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeres frissítés!',
            text: 'A munkagép sikeresen frissítve.',
            variant: 'success',
          },
        })
        this.$router.push('/work-machines/list')
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hiba történt!',
            text: 'A munkagép frissítése sikertelen.',
            variant: 'danger',
          },
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
